import styled, { keyframes } from 'styled-components';

import fadeIn from 'react-animations/lib/fade-in';

import devices, { sizes } from '~/styles/configs/devices';

const fadeInAnimation = keyframes`${fadeIn}`;

export const Container = styled.tr`
  animation: 1s ${fadeInAnimation};

  @media ${`${devices.mobileS} and (max-width: ${sizes.tablet})`} {
    display: block;

    &:not(:last-of-type) {
      margin-bottom: 30px;
    }
  }

  @media ${devices.laptop} {
    &:last-of-type td {
      border-bottom: none;
    }
  }
`;
